import http from '../widget-http'

export default class WidgetChatServices {
  async getMessageForChat(attendanceId, pageNumber, pageSize) {
    let res = await http.get(`v1/attendant/${attendanceId}?PageNumber=${pageNumber}&PageSize=${pageSize}`);
    return res.data;
  }

  async sendMessageToAttendant(attendanceId, data, FunctionProgress) {
    let res = await http.post(`v1/attendant/${attendanceId}/send-message-attendant`, data,
      {
        onUploadProgress: (event) => {
          let progress = Math.round((event.loaded * 100) / event.total);
          FunctionProgress(progress);
        },
      });

    return res.data;
  }
}